<div *ngIf="visibleloader" class="loader_style">
    <mat-spinner diameter="50" strokeWidth="4"></mat-spinner>
</div>
<div *ngIf="!visibleloader">
    <div class="row" *ngIf="report_data">
        <div class="col-md-4 col-sm-12">
            <div class="card-box">
                <h1 class="card-title hd-cd">Mode of Payments</h1>
                <div class="card-block">
                    <div class="table-responsive">
                        <table class="table custom-table" style="border: none;">
                            <thead>
                                <tr>
                                    <th>Type</th>

                                    <th class="text-right">Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let data of report_data.mode_of_payments | keyvalue">
                                    <td>{{data.key}}</td>

                                    <td class="text-right">{{formatNumber(data.value)}}</td>
                                </tr>
                                <tr>
                                    <td><b>Total</b> </td>

                                    <td class="text-right"><b>{{formatNumber(report_data.total_sales)}}</b></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-4 col-sm-12" *ngIf="report_data.bill_type_details?.length>0">
            <div class="card-box">
                <h1 class="card-title hd-cd">Bill Type Details</h1>
                <div class="table-responsive">
                    <table class="table custom-table" style="border: none;">
                        <thead>
                            <tr>
                                <th>Type</th>
                                <th>Count</th>
                                <th class="text-right">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of report_data.bill_type_details">
                                <td>{{data.order_option_name}}</td>
                                <td>{{data.ordercount}}</td>
                                <td class="text-right">{{formatNumber(data.totalamount)}}</td>
                            </tr>
                            <tr>
                                <td><b>Total</b> </td>
                                <td>{{report_data.bill_type_total_order_count}}</td>
                                <td class="text-right"><b>{{formatNumber(report_data.bill_type_grand_total)}}</b></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>


        <div class="col-md-4 col-sm-12" *ngIf="report_data.delivery_partners?.length>0">
            <div class="card-box">
                <h1 class="card-title hd-cd">Amount - By Delivery Partners</h1>
                <div class="table-responsive">
                    <table class="table custom-table" style="border: none;">
                        <thead>
                            <tr>
                                <th>Delivery Partners</th>
                                <th>Count</th>
                                <th class="text-right">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of report_data.delivery_partners">
                                <td>{{data.name}}</td>
                                <td>{{data.ordercount}}</td>
                                <td class="text-right">{{formatNumber(data.totalamount)}}</td>
                            </tr>
                            <tr>
                                <td><b>Total</b> </td>
                                <td>{{report_data.delivery_partners_count}}</td>
                                <td class="text-right"><b>{{formatNumber(report_data.delivery_partners_total)}}</b></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="col-md-4 col-sm-12" *ngIf="report_data.receipts_data?.length>0">
            <div class="card-box">
                <h1 class="card-title hd-cd">Receipt </h1>
                <div class="table-responsive">
                    <table class="table custom-table" style="border: none;">
                        <thead>
                            <tr>
                                <th>Account Head</th>
                                <th class="text-right">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of report_data.receipts_data">
                                <td>{{data.account_head_name}}</td>
                                <td class="text-right">{{formatNumber(data.amount)}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- <span class="text">{{formatNumber(report_data.total_receipts)}}</span> -->
            </div>
        </div>
        <div class="col-md-4 col-sm-12" *ngIf="report_data.payment_data?.length>0">
            <div class="card-box">
                <h1 class="card-title hd-cd">Payment </h1>
                <div class="table-responsive">
                    <table class="table custom-table" style="border: none;">
                        <thead>
                            <tr>
                                <th>Account Head</th>
                                <th class="text-right">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of report_data.payment_data">
                                <td>{{data.account_head_name}}</td>
                                <td class="text-right">{{formatNumber(data.amount)}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- <span class="text">{{formatNumber(report_data.total_payment)}}</span> -->
            </div>
        </div>
        <div class="col-md-4 col-sm-12" *ngIf="report_data.amount_by_waiter?.length>0">
            <div class="card-box">
                <h1 class="card-title hd-cd">Amount - By Waiter </h1>
                <div class="table-responsive">
                    <table class="table custom-table" style="border: none;">
                        <thead>
                            <tr>
                                <th>Waiter</th>
                                <th>Count</th>
                                <th class="text-right">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of report_data.amount_by_waiter">
                                <td>{{data.user_name}}</td>
                                <td>{{data.ordercount}}</td>
                                <td class="text-right">{{formatNumber(data.totalamount)}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- <span class="text">{{formatNumber(waiter_total)}}</span> -->
            </div>
        </div>
        <div class="col-md-4 col-sm-12" *ngIf="report_data.amount_by_settler?.length>0">
            <div class="card-box">
                <h1 class="card-title hd-cd">Amount - By Settler </h1>
                <div class="table-responsive">
                    <table class="table custom-table" style="border: none;">
                        <thead>
                            <tr>
                                <th>Settler</th>
                                <th>Count</th>
                                <th class="text-right">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of report_data.amount_by_settler">
                                <td>{{data.user_name}}</td>
                                <td>{{data.ordercount}}</td>
                                <td class="text-right">{{formatNumber(data.totalamount)}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- <span class="text">{{formatNumber(waiter_total)}}</span> -->
            </div>
        </div>
        <div class="col-md-4 col-sm-12" *ngIf="report_data.amount_by_device?.length>0">
            <div class="card-box">
                <h1 class="card-title hd-cd">Amount - By  Device </h1>
                <div class="table-responsive">
                    <table class="table custom-table" style="border: none;">
                        <thead>
                            <tr>
                                <th>Device</th>
                                <th>Count</th>
                                <th class="text-right">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of report_data.amount_by_device">
                                <td>{{data.device_name}}</td>
                                <td>{{data.ordercount}}</td>
                                <td class="text-right">{{formatNumber(data.totalamount)}}</td>
                            </tr>
                            <tr>
                                <td><b>Total</b> </td>
                                <td>{{report_data.amount_by_device_count}}</td>
                                <td class="text-right"><b>{{formatNumber(report_data.amount_by_device_total)}}</b></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="col-md-4 col-sm-12" *ngIf="report_data.amount_by_delivertBoy?.length>0">
            <div class="card-box">
                <h1 class="card-title hd-cd">Amount - By  Delivery Boys </h1>
                <div class="table-responsive">
                    <table class="table custom-table" style="border: none;">
                        <thead>
                            <tr>
                                <th>Delivery Boys</th>
                                <th>Count</th>
                                <th class="text-right">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of report_data.amount_by_delivertBoy">
                                <td>{{data.user_name}}</td>
                                <td>{{data.ordercount}}</td>
                                <td class="text-right">{{formatNumber(data.totalamount)}}</td>
                            </tr>
                            <tr>
                                <td><b>Total</b> </td>
                                <td>{{report_data.amount_by_deliveryBoy_count}}</td>
                                <td class="text-right"><b>{{formatNumber(report_data.amount_by_deliveryBoy_total)}}</b>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="col-md-4 col-sm-12" *ngIf="report_data.amount_by_cashier?.length>0">
            <div class="card-box">
                <h1 class="card-title hd-cd">Amount - By  Cashier </h1>
                <div class="table-responsive">
                    <table class="table custom-table" style="border: none;">
                        <thead>
                            <tr>
                                <th>Cashier</th>
                                <th>Shift</th>
                                <th>Count</th>
                                <th class="text-right">Cash</th>
                                <th class="text-right">Card</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of report_data.amount_by_cashier">
                                <td>{{data.user_name}}</td>
                                <td>{{data.shift_name}}</td>
                                <td>{{data.ordercount}}</td>
                                <td class="text-right">{{formatNumber(data.cash_amount)}}</td>
                                <td class="text-right">{{formatNumber(data.card_amount)}}</td>
                            </tr>
                            <tr>
                                <td><b>Total</b> </td>
                                <td></td>
                                <td>{{report_data.amount_by_cashier_count}}</td>
                                <td class="text-right"><b>{{formatNumber(report_data.amount_by_cashier_cash_total)}}</b>
                                </td>
                                <td class="text-right"><b>{{formatNumber(report_data.amount_by_cashier_card_total)}}</b>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- <span class="text">{{formatNumber(cashier_total)}}</span> -->
            </div>
        </div>
        <div class="col-md-4 col-sm-12" *ngIf="report_data.amount_by_kiosk?.length>0">
            <div class="card-box">
                <h1 class="card-title hd-cd">Amount - By  Counter </h1>
                <div class="table-responsive">
                    <table class="table custom-table" style="border: none;">
                        <thead>
                            <tr>
                                <th>Counter</th>
                                <th>Count</th>
                                <th class="text-right">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of report_data.amount_by_kiosk">
                                <td>{{data.kiosk_name}}</td>
                                <td>{{data.ordercount}}</td>
                                <td class="text-right">{{formatNumber(data.totalamount)}}</td>
                            </tr>
                            <tr>
                                <td><b>Total</b> </td>
                                <td>{{report_data.amount_by_kiosk_count}}</td>
                                <td class="text-right"><b>{{formatNumber(report_data.amount_by_kiosk_total)}}</b></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="col-md-4 col-sm-12" *ngIf="report_data.cancelled_items?.length>0">
            <div class="card-box">
                <h1 class="card-title hd-cd">LIST OF CANCELLED ITEMS </h1>
                <div class="card-block">
                    <div class="table-responsive">
                        <table class="table custom-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Bill No</th>
                                    <th>Item Name</th>
                                    <th>Quantity</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let data of report_data.cancelled_items;let i=index">
                                    <td>{{i+1}}</td>
                                    <td>{{data.bill_no}}</td>
                                    <td>{{data.product_name}}</td>
                                    <td>{{data.qty}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-4 col-sm-12" *ngIf="report_data.cancelled_orders?.length>0">
            <div class="card-box">
                <h1 class="card-title hd-cd">LIST OF CANCELLED ORDERS </h1>
                <div class="table-responsive">
                    <table class="table custom-table" style="border: none;">
                        <thead>
                            <tr>
                                <th>Bill No</th>
                                <th class="text-right">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of report_data.cancelled_orders">
                                <td>{{data.bill_no}}</td>
                                <td class="text-right">{{formatNumber(data.net_amount)}}</td>
                            </tr>
                            <tr>
                                <td><b>Total</b> </td>
                                <td class="text-right"><b>{{formatNumber(report_data.cancelled_orders_total)}}</b></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
       
        <!-- <div class="col-md-4 col-sm-12" *ngIf="report_data.cancelled_bills?.length>0">
            <div class="card-box">
                <h1 class="card-title hd-cd">LIST OF CANCELLED BILLS </h1>
                <div class="table-responsive">
                    <table class="table custom-table" style="border: none;">
                        <thead>
                            <tr>
                                <th>Bill No</th>
                                <th class="text-right">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of report_data.cancelled_bills">
                                <td>{{data.bill_no}}</td>
                                <td class="text-right">{{formatNumber(data.net_amount)}}</td>
                            </tr>
                            <tr>
                                <td><b>Total</b> </td>
                                <td class="text-right"><b>{{formatNumber(report_data.cancelled_bills_total)}}</b></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div> -->
        <div class="col-md-4 col-sm-12" *ngIf="report_data.disc_bill_type_details?.length>0">
            <div class="card-box">
                <h1 class="card-title hd-cd">Discount Bill Type</h1>
                <div class="table-responsive">
                    <table class="table custom-table" style="border: none;">
                        <thead>
                            <tr>
                                <th>Type</th>
                                <th>Count</th>
                                <th class="text-right">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of report_data.disc_bill_type_details">
                                <td>{{data.order_option_name}}</td>
                                <td>{{data.ordercount}}</td>
                                <td class="text-right">{{formatNumber(data.disc_amount)}}</td>
                            </tr>
                            <tr>
                                <td><b>Total</b> </td>
                                <td>{{report_data.disc_bill_type_details_count}}</td>
                                <td class="text-right"><b>{{formatNumber(report_data.disc_bill_type_details_total)}}</b>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="col-md-4 col-sm-12" *ngIf="report_data.amount_by_category?.length>0">
            <div class="card-box">
                <h1 class="card-title hd-cd">AMOUNT - BY CATEGORY </h1>
                <div class="table-responsive">
                    <table class="table custom-table" style="border: none;">
                        <thead>
                            <tr>
                                <th>Category</th>
                                <th class="text-right">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of report_data.amount_by_category">
                                <td>{{data.category_name}}</td>
                                <td class="text-right">{{formatNumber(data.totalamount)}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- <span class="text">{{formatNumber(Category_total)}}</span> -->
            </div>
        </div>
        <div class="col-md-4 col-sm-12" *ngIf="report_data.amount_by_main_category?.length>0">
            <div class="card-box">
                <h1 class="card-title hd-cd">AMOUNT - BY MAIN CATEGORY </h1>
                <div class="table-responsive">
                    <table class="table custom-table" style="border: none;">
                        <thead>
                            <tr>
                                <th>Main Category</th>
                                <th class="text-right">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of report_data.amount_by_main_category">
                                <td>{{data.category_name}}</td>
                                <td class="text-right">{{formatNumber(data.totalamount)}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- <span class="text">{{formatNumber(main_Category_total)}}</span> -->
            </div>
        </div>

        <div class="col-md-4 col-sm-12" *ngIf="report_data.stock_details?.length > 0">
            <div class="card-box">
            <h1 class="card-title hd-cd">Stock Details</h1>
            <div class="table-responsive">
                <table class="table custom-table" style="border: none;">
                <thead>
                    <tr>
                    <th>Product Name</th>
                    <th class="text-right">Opening Stock</th>
                    <th class="text-right">Closing Stock</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let data of report_data.stock_details">
                    <td>{{data.product_name}}</td>
                    <td class="text-right">{{data.opening_stock}}</td>
                    <td class="text-right">{{data.closing_stock}}</td>
                    </tr>
                </tbody>
                </table>
            </div>
            </div>
        </div>

       


        <div class="col-md-12 col-sm-12" *ngIf="report_data.shiftArray?.length>0">
            <div class="card-box">
                <div class="table-responsive">
                    <table class="table mb-0">
                        <thead>
                            <tr>
                                <!-- <th>Shift</th> -->
                                <th>User</th>
                                <th>Device</th>
                                <th>Counter</th>
                                <th>Shift</th>
                                <th>Open</th>
                                <th>Opening Cash</th>
                                <th>Close</th>
                                <th>Closing Cash</th>
                                <th>System Cash</th>
                                <th>Difference</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let shift of report_data.shiftArray; let i= index" class="ds">
                                <!-- <td>{{ shift.shift_name }}</td> -->
                                <td>{{ shift.user_name }}</td>
                                <td>{{ shift.device_name }}</td>
                                <td>{{ shift.kiosk_name }}</td>
                                <td>{{ shift.shift_name }}</td>
                                <td>{{ shift.opening_time }}</td>
                                <td>{{ formatNumber(shift.opening_balance) }}</td>
                                <td>{{ shift.closing_time }}</td>
                                <td>{{shift.closing_balance }}</td>
                                <td>{{formatNumber(shift.system_balance)}}</td>
                                <td>{{formatNumber(shift.system_balance - shift.closing_balance) }}</td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="col-md-12 col-sm-12" *ngIf="!report_data">
            <h3 class="data-text">No data is Available</h3>
        </div>
    </div>
    <div class="row" *ngIf="!report_data">
        <div class="col-md-12 col-sm-12">
            <h3 class="data-text">No data is Available</h3>
        </div>
    </div>
</div>